export default __webpack_public_path__ + "static/media/GroupPlus1.7d205e8f.svg";